import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import {countries, devConfig, profile} from 'config/config'; // Importing development configuration and user profile
import 'webix/photo'; // Importing Webix photo component
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

export default class FilterReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            // Configuration for date selection
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for date range
                            name: 'activationDate',
                            id: 'activationDate',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Activación'), // Translated label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for date range
                            name: 'redemptionDate',
                            id: 'redemptionDate',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Redención'), // Translated label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for date range
                            name: 'expirationDate',
                            id: 'expirationDate',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Expiración'), // Translated label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text',
                            name: 'userId',
                            id: 'userId',
                            type: 'number',
                            label: "<span class='icon-user'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                            invalidMessage: _('ID Usuario is required'),
                        },
                        {
                            view: 'richselect',
                            name: 'state',
                            id: 'state',
                            label: "<span class='icon-state'></span>" + _('Estado del Giro'), // Label for activation state
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'P', value: _('Pendiente') }, // Option for all
                                { id: 'PR', value: _('Pendiente Rollback') }, // Option for activated
                                { id: 'PP', value: _('Pendiente Procesar') }, // Option for activated
                                { id: 'A', value: _('Activa') }, // Option for deactivated
                                { id: 'R', value: _('Redimido') }, // Option for deactivated
                                { id: 'E', value: _('Expirado') }, // Option for deactivated
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'rouletteId',
                            id: 'rouletteId',
                            type: 'number',
                            label: "<span class='icon-user'></span>" + _('ID Ruleta'),
                            labelPosition: 'top',
                            placeholder: _('ID Ruleta'),
                            invalidMessage: _('Roulette ID is required'),
                        },
                        {
                            view: 'text',
                            name: 'rouletteName',
                            id: 'rouletteName',
                            label: "<span class='icon-user'></span>" + _('Nombre de Ruleta'),
                            labelPosition: 'top',
                            placeholder: _('Nombre de Ruleta'),
                            invalidMessage: _('Roulette Name is required'),
                        },
                        {
                            view: 'richselect',
                            name: 'typeAward',
                            id: 'typeAward',
                            label: "<span class='icon-gift'></span>" + _('Tipo de Premio'), // Label for activation state
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'freebet', value: _('Freebet') }, // Option for all
                                { id: 'freespin', value: _('Freespin') }, // Option for activated
                                { id: 'bonus', value: _('Bono') }, // Option for activated
                                { id: 'cash', value: _('Dinero') }, // Option for deactivated
                                { id: 'physical_award', value: _('Premio Físico') }, // Option for deactivated
                                { id: 'extra_spin', value: _('Giro Extra') }, // Option for deactivated
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'partnerId',
                            id: 'partnerId',
                            minWidth: 200,
                            label: _('Partner'), // Partner label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.PartnerSelected, // Selected partner from profile
                            options: profile.Partners, // List of partners
                            hidden: !profile.Partners.length > 2, // Hide if less than 3 partners
                        },
                        {
                            view: 'richselect',
                            name: 'countryId',
                            id: 'countryId',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: countries.id, // Default country selection
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Country flag template
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Permission check
                            css: 'prm-filterByCountry',
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            // Upper section containing filters
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including date selection and transaction ID
                },
            ],
        };
        const buttons = {
            // Button configuration for the main filter section
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Translated label
                    width: 100,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Translated label
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        console.log(this.getRoot().getValues())
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('rouletteReport:filter', [
                            filterdata, // Trigger filter event with collected data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            // Button configuration for the popup filter section
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button for popup
                    value: _('Limpiar'), // Translated label
                    width: 100,
                    click: () => {
                        $$('myForm2').clear(); // Clears the popup form
                    },
                },
                {
                    view: 'button', // Consult button for popup
                    value: _('Consultar'), // Translated label
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get popup form values
                        this.app.callEvent('userAffiliates:filter', [
                            filterdata, // Trigger filter event with collected data
                        ]);
                    },
                },
            ],
        };
        const accordion_section2 = {
            // Accordion section for main filters
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Translated header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Including upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            // Accordion section for popup filters
            padding: 10,
            rows: [upper_section, buttons2], // Including upper section and buttons
        };
        return {
            view: 'form', // Main form configuration
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { id: 'right2', height: 1, width: screen.width - 54 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }
    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('activationDate').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal configuration based on language
        });
        $$('redemptionDate').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal configuration based on language
        });
        $$('expirationDate').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal configuration based on language
        });
    }
}

// FILE DOCUMENTED
